import {I18n} from '@aws-amplify/core';
import {NavLink} from 'react-router-dom';

import {formatTimestamp} from '../../../utils/TableTimestamps';
import {Customer} from '../types';

export const getColumns = () => [
    {
        title: I18n.get('Name'),
        width: '1fr',
        render: (item: Customer) => (
            <NavLink
                to={`/customers/${item.id}`}
                style={{color: 'var(--mantine-color-blue-6)'}}
            >
                {item.name}
            </NavLink>
        ),
    },
    {
        title: I18n.get('Email'),
        width: '1fr',
        render: (item: Customer) => item.email,
    },
    {
        title: I18n.get('Phone'),
        width: '1fr',
        render: (item: Customer) => item.phone,
    },
    {
        title: I18n.get('Created'),
        width: '1fr',
        render: (item: Customer) => formatTimestamp(item.created as unknown as number * 1000),
    },
];

// Keep backward-compatible export for any remaining consumers
export const columns = getColumns();
